var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiClientHeaderBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 703 364",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.7,
    filter: "url(#filter0_f_102_10011)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421.345 87.8808C571.867 186.505 570.435 282.03 550.904 317.465C512.948 387.593 552.847 513.099 637.957 532.301C723.066 551.502 853.619 546.772 898.083 435.736C942.546 324.701 858.414 206.152 749.432 1.05615C640.45 -204.039 711.528 -240.495 661.771 -361.27C612.013 -482.045 296.347 -503.752 249.942 -361.27C203.538 -218.788 233.194 -35.3991 421.345 87.8808Z",
    fill: "url(#paint0_linear_102_10011)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M421.345 87.8808C571.867 186.505 570.435 282.03 550.904 317.465C512.948 387.593 552.847 513.099 637.957 532.301C723.066 551.502 853.619 546.772 898.083 435.736C942.546 324.701 858.414 206.152 749.432 1.05615C640.45 -204.039 711.528 -240.495 661.771 -361.27C612.013 -482.045 296.347 -503.752 249.942 -361.27C203.538 -218.788 233.194 -35.3991 421.345 87.8808Z",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_102_10011",
    x: -19.9026,
    y: -710.647,
    width: 1180.63,
    height: 1502.13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_102_10011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_10011",
    x1: 158.987,
    y1: -257.221,
    x2: 827.354,
    y2: -236.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E42DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#5BB099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336268,
    stopColor: "#67D2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632216,
    stopColor: "#3D78D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81533,
    stopColor: "#212477"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiClientHeaderBg);
export default __webpack_public_path__ + "static/media/multi-client-header-bg.1186871c221e9833ed1f090b9b9724f7.svg";
export { ForwardRef as ReactComponent };